<template>
    <div class="pd-select-history">
        <div class="wrapper-select-history">
            <div
                class="wrapper-select"
                :class="
                    $route.name === 'historyearnpoint'
                        ? 'select-collect-points'
                        : 'select-use-points'
                "
                @click="gotoPath('historyearnpoint')"
            >
                <span>คะแนนที่ได้รับ</span>
            </div>
            <div
                class="wrapper-select"
                :class="
                    $route.name === 'historyburnpoint'
                        ? 'select-collect-points'
                        : 'select-use-points'
                "
                @click="gotoPath('historyburnpoint')"
            >
                <span>คะแนนที่แลก</span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "History-earn-point",
    components: {},
    props: {},
    data: function () {
        return {};
    },
    watch: {},
    created: function () {},
    mounted() {},
    methods: {
        gotoPath(path) {
            if (this.$route.name !== path) {
                this.$router.push("/" + path);
                // if (path !== 'historyburnpoint') {
                // }
            }
        },
    },
};
</script>

<style lang="scss" scoped>
@import "@/style/_mixin.scss";
.pd-select-history {
    padding: 25px 32px;
}
.wrapper-select-history {
    display: flex;
    border-radius: 18px;
    font-size: 16px;
    color: #fff;
    font-family: "PromptRegular";
    cursor: pointer;

    .wrapper-select {
        width: 50%;
        display: flex;
        justify-content: center;
        align-content: center;
    }
    .select-collect-points {
        background-color: $color-text;
        border-radius: 40px;
        padding: 8px 0;
        margin: 0px 5px;
    }
    .select-use-points {
        background-color: $color-light-grey-500;
        color: $color-text;
        border-radius: 40px;
        padding: 8px 0;
        margin: 0px 5px;
    }
}
</style>
